import { useCallback, useEffect, useState } from "react";
import { DEFAULT_POKEMON_PAGE } from "../constants/pokemon";
import { fetchPokemonList } from "../services/pokemonService";

function usePokemonList() {
  const [pokemons, setPokemons] = useState([]);
  const [currentPageUrl, setCurrentPageUrl] = useState(DEFAULT_POKEMON_PAGE);
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [prevPageUrl, setPrevPageUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function loadPage() {
      setLoading(true);
      setError(null);

      try {
        const page = await fetchPokemonList(currentPageUrl);

        if (!isMounted) {
          return;
        }

        setPokemons(page.results);
        setNextPageUrl(page.next);
        setPrevPageUrl(page.previous);
        window.scrollTo(0, 0);
      } catch (requestError) {
        if (isMounted) {
          setError(requestError);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadPage();

    return () => {
      isMounted = false;
    };
  }, [currentPageUrl]);

  const gotoNextPage = useCallback(() => {
    if (nextPageUrl) {
      setCurrentPageUrl(nextPageUrl);
    }
  }, [nextPageUrl]);

  const gotoPrevPage = useCallback(() => {
    if (prevPageUrl) {
      setCurrentPageUrl(prevPageUrl);
    }
  }, [prevPageUrl]);

  return {
    pokemons,
    loading,
    error,
    nextPageUrl,
    prevPageUrl,
    gotoNextPage,
    gotoPrevPage,
  };
}

export default usePokemonList;
